import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ConfigMissing from './components/ConfigMissing';
import { isConfigured } from './lib/db';
import './styles/tokens.css';
import './styles/app.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>{isConfigured ? <App /> : <ConfigMissing />}</React.StrictMode>,
);
